import { MatenRequestResponse } from '../../../shared';
import BaseOverviewStore, {
    type ApiResponse,
    type BaseStoreState,
} from '../../../shared/stores/baseOverviewStore';

/**
 * Load all managers and make it possible to manage them
 */
class ManagerStore extends BaseOverviewStore<any> {
    protected storageKey(): string {
        return 'manager';
    }

    protected defaultSortField(): string {
        return 'id';
    }

    // Implement required abstract methods
    protected getApiEndpoint(): string {
        return 'manager';
    }

    protected getApiPath(): string {
        return 'query';
    }

    protected buildApiParams(page: number): any {
        return {
            sortvalue: this.sortField,
            sort: this.sortOrder === 1 ? 'asc' : 'desc',
            search: this.searchValue || '',
            page,
        };
    }

    protected processApiResponse(response: ApiResponse): any[] {
        return response.json.data;
    }

    protected getStorageState(): BaseStoreState {
        return {
            sortOrder: this.sortOrder,
            sortField: this.sortField,
            searchValue: this.searchValue,
        };
    }

    protected applyStorageState(state: BaseStoreState): void {
        this.sortOrder = state.sortOrder || 1;
        this.sortField = state.sortField || this.defaultSortField();
        this.searchValue = state.searchValue || '';
    }

    // Manager-specific methods
    public async onDeleteManager(manager: any): Promise<MatenRequestResponse> {
        try {
            const response = await this.sdk.fetchApi('manager', 'delete', {
                manager_id: manager.id,
            });

            if (response.status === 200) {
                return { success: true, status: 200, data: response.json };
            } else {
                return { success: false, status: response.status, error: response.json.error };
            }
        } catch (error) {
            return { success: false, status: 500 };
        }
    }

    public async onDialogLeave(dialog: string, event: any = null): Promise<void> {
        if (dialog === 'manager' && event?.event === 'SAVED') {
            await this.fetchList(this.latestPage);
        } else {
            await super.onDialogLeave(dialog, event);
        }
    }

    // Computed property for compatibility
    get allManagers(): Array<any> | null {
        return this.allItems;
    }

    // Aliases for compatibility with existing code
    get managerList(): Array<any> {
        return this.list;
    }

    get managerListLoading(): boolean {
        return this.listLoading;
    }
}

export default ManagerStore;
